
import Vue from 'vue'

import DailyMenuOffer from '@/model/DailyMenuOffer'
import CalendarGroupKindItem from '@/components/order/CalendarGroupKindItem.vue'
import MenuReservationItem from '@/model/MenuReservationItem'
import router from '@/router'
import {RawLocation} from 'vue-router/types/router'
import moment from 'moment'
import {Component, Prop} from "vue-property-decorator";
import CalendarEventForDay from "@/model/CalendarEventForDay";
import {GET_CALENDAR_EVENTS, GET_MODE} from "@/store/getter-types";
import {SET_SELECTED_MENU_ITEM} from "@/store/action-types";
import MenuGroupItem from "@/model/MenuGroupItem";
import _ from "lodash";

@Component({
  components: {
    CalendarGroupKindItem
  }
})

export default class CalendarOfferItem extends Vue {

  @Prop({type: Object as () => DailyMenuOffer, required: true}) offerItem!: DailyMenuOffer
  @Prop({type: Date}) date!: Date
  @Prop({type: Array as () => MenuReservationItem[]}) reservationItem!: MenuReservationItem[]

  private setFreeDay: boolean = false
  private events: CalendarEventForDay[] | undefined = undefined

  get getFirstReservationItem (): MenuReservationItem | undefined {
    return _.first(this.reservationItem)
  }

  get getMemuGroupItem (): any {
    let  foundItem: MenuGroupItem | undefined = undefined
    if(this.getFirstReservationItem && this.getFirstReservationItem.topMenuGroup && this.getFirstReservationItem.topMenuGroup.title) {
      foundItem = this.offerItem.menuGroupList.find((item: MenuGroupItem) => this.getFirstReservationItem!.topMenuGroup.title === item.title)
    }
    return foundItem
  }

  get cardClass(): string | undefined {
      let localeIsoWeek = localStorage.getItem('uiLanguageCodeApp') || navigator.language || process.env.VUE_APP_I18N_LOCALE || 'sk'
    if (this.date && this.reservationItem) {
      if (moment(this.offerItem.date).locale(localeIsoWeek).isSame(this.date, 'date')) {
        return 'light-green lighten-3'
      }
    }
    return undefined
  }

  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  get getEventName(): string{
    const foundEvent: CalendarEventForDay | undefined = this.events!.find((item: CalendarEventForDay) => moment(item.date).format('DD.M.YYYY') == moment(this.offerItem.formatedDbDate).format('DD.M.YYYY'))
    if (foundEvent!.kind.name == 'holiday') {
      return 'Prázdniny'
    } else if(foundEvent!.kind.name == 'free_day') {
      return 'Voľný deň'
    } else {
      return ''
    }
  }

  getCurrentEvent(): void {
    if (this.events) {
      const foundEvent: CalendarEventForDay | undefined = this.events.find((item: CalendarEventForDay) => moment(item.date).format('DD.M.YYYY') == moment(this.offerItem.formatedDbDate).format('DD.M.YYYY'))
      this.setFreeDay = !!foundEvent
    }
  }

  getReservationItem (menuGroupItem: MenuGroupItem): MenuReservationItem | null {
    const foundReservationItem: MenuReservationItem | undefined = this.reservationItem.find((item: MenuReservationItem) =>  item.topMenuGroup.id === menuGroupItem.id)
    return foundReservationItem ? foundReservationItem : null
  }

  onDayMenuClick(): void {
    router.push({
      name: 'Order',
      params: {
        isoWeek: this.$route.params.isoWeek,
        date: this.offerItem.formatedDbDate
      }
    } as RawLocation).catch((err: Error) => {
    })
    if(this.getFirstReservationItem) {
      this.$store.dispatch(SET_SELECTED_MENU_ITEM, this.getFirstReservationItem!.topMenuGroup.title)
    } else {
      this.$store.dispatch(SET_SELECTED_MENU_ITEM, 'Denné menu')
    }
  }

  mounted(): void {
    this.events = this.$store.getters[GET_CALENDAR_EVENTS]
    this.getCurrentEvent()
  }

}
